import React, { Component } from 'react'
import styled from 'styled-components'
import WidgetContainer from '../containers/WidgetContainer'

const StyledReadoWidget = styled.iframe`
border: 1px solid #CECECE;
border-radius: 3px;
width: 100%;
`

export default class Reado extends Component {
  render () {
    const {
      widget,
      googleAnalytics,
      widget: {
        meta: {
          themeName,
          utmSource
        }
      }
    } = this.props

    return (
      <WidgetContainer googleAnalytics={googleAnalytics} widget={widget}>
        <StyledReadoWidget src={`https://app.reado.cz/avm-widget/${themeName}?utm_source=${utmSource}`} width='100%' height='315' title='AVM' />
      </WidgetContainer>
    )
  }
}
